import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { IconComponent, IconSize } from '@ui/aos-lib';
import { type Observable, take } from 'rxjs';

import type { RouteItem } from '../../../routes/app.types';
import { ComponentMediaObserverService } from '../../../services/utility/component-media-observer.service';
import { Breakpoints } from '../../../services/utility/media-observer.types';
import { SideMenuCollapsedComponent } from './side-menu-collapsed/side-menu-collapsed.component';
import { SideMenuExpandedComponent } from './side-menu-expanded/side-menu-expanded.component';
import { SideMenuService } from './side-menu.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, IconComponent, NgOptimizedImage, SideMenuCollapsedComponent, SideMenuExpandedComponent],
  providers: [ComponentMediaObserverService, SideMenuService],
  selector: 'aos-side-menu',
  styleUrls: ['./side-menu.component.scss'],
  templateUrl: './side-menu.component.html'
})
export class SideMenuComponent implements OnInit {
  readonly mediaObserver = inject(ComponentMediaObserverService);

  @Input() expanded = true;
  @Output() toggleClicked = new EventEmitter<void>();

  protected readonly hasBreakpointL$ = this.mediaObserver.hasBreakpoint(Breakpoints.L);

  protected readonly collapseButtonCollapsedIconSize = IconSize.MD;
  protected readonly collapseButtonExpandedIconSize = IconSize.LG;
  protected readonly collapseButtonIconColor = 'currentColor';
  protected readonly collapseButtonIconName = 'menu_collapse';

  private readonly sideMenuService = inject(SideMenuService);
  protected readonly menuItems$: Observable<readonly RouteItem[]> = this.sideMenuService.filteredMenuItems$;

  ngOnInit(): void {
    this.menuItems$.pipe(take(1)).subscribe(menuItems => {
      const selectedParentItem = menuItems.find(item => item.selected && item.children.length);
      selectedParentItem?.expandItem();
    });
  }
}
